<template>
  <footer class="footer">
    <div class="footer-content container">
      <!-- Company Info Section -->
      <div class="footer-section company-info">
        <div class="company-logo">
          <img src="../assets/logo.png" alt="AMIS Logo" class="footer-logo" width="230" height="102" loading="lazy">
        </div>
        <p class="company-description">
          AMIS BUSINESS SERVICE HK LIMITED<br>
          友誼商業服務香港有限公司
        </p>
        <p class="company-description">
          教育陪伴 · 遊學 · 旅遊<br>
          旗下 AI 服務品牌：Baikan Buddy 百看精靈
        </p>
        <div class="contact-info">
          <div class="contact-item">
            <i class="fas fa-envelope"></i>
            <a href="mailto:meng@amis.hk">meng@amis.hk</a>
          </div>
          <div class="contact-item">
            <i class="fas fa-map-marker-alt"></i>
            <span>香港九龍觀塘開源道 49 號創貿廣場 16 樓 1608 室</span>
          </div>
        </div>
      </div>

      <!-- Quick Links Section -->
      <div class="footer-section quick-links">
        <h3 class="footer-title">快速連結</h3>
        <ul class="footer-links">
          <li><router-link to="/about">關於我們</router-link></li>
          <li><router-link to="/service">我們的服務</router-link></li>
          <li><router-link to="/news">新聞報導</router-link></li>
          <li><router-link to="/contact">聯繫我們</router-link></li>
        </ul>
      </div>

      <!-- Services Section -->
      <div class="footer-section services">
        <h3 class="footer-title">服務項目</h3>
        <ul class="footer-links">
          <li><router-link to="/service">教育陪伴</router-link></li>
          <li><router-link to="/service">遊學服務</router-link></li>
          <li><router-link to="/service">旅遊服務</router-link></li>
          <li><router-link to="/service">商務出行</router-link></li>
        </ul>
      </div>

      <!-- Social & QR Section -->
      <div class="footer-section social-qr">
        <h3 class="footer-title">關注我們</h3>
        <div class="qr-code">
          <img src="../assets/qr_about_risk.jpg" alt="微信公眾號二維碼" class="qr-image" width="100" height="100" loading="lazy">
          <p class="qr-text">掃描關注微信公眾號</p>
        </div>
        <div class="social-links">
          <span class="social-link">
            <img src="../assets/wechat_logo.png" alt="WeChat" class="social-icon" width="36" height="36" loading="lazy">
          </span>
          <span class="social-link">
            <img src="../assets/weibo_logo.png" alt="Weibo" class="social-icon" width="36" height="36" loading="lazy">
          </span>
          <span class="social-link">
            <img src="../assets/facebook_logo.png" alt="Facebook" class="social-icon" width="36" height="36" loading="lazy">
          </span>
          <span class="social-link">
            <img src="../assets/linkedin_logo.png" alt="LinkedIn" class="social-icon" width="36" height="36" loading="lazy">
          </span>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <div class="legal-entity">
          <p class="legal-entity-line">
            AMIS BUSINESS SERVICE HK LIMITED（友誼商業服務香港有限公司）· 商業登記號碼 BR 75158179
          </p>
          <p class="legal-entity-line">
            登記地址：香港九龍觀塘開源道 49 號創貿廣場 16 樓 1608 室
            <span class="legal-entity-en">Room 1608, 16/F, APAC Plaza, 49 Hoi Yuen Road, Kwun Tong, Kowloon, Hong Kong</span>
          </p>
          <p class="legal-entity-line">
            電郵：<a href="mailto:meng@amis.hk">meng@amis.hk</a>
            <span class="legal-entity-sep">·</span>
            品牌服務：Baikan Buddy 百看精靈
          </p>
          <p class="legal-entity-line">
            業務範圍：教育陪伴 Education Companion · 遊學 Study Tour · 旅遊 Travel
          </p>
        </div>
        <div class="footer-bottom-content">
          <p class="copyright">
            © {{ currentYear }} AMIS BUSINESS SERVICE HK LIMITED<br>
            商業登記號 BR：75158179 · 公司註冊編號 CI：3263340
          </p>
          <div class="footer-bottom-links">
            <a href="/legal" class="footer-bottom-link">法律資料</a>
            <a href="/privacy" class="footer-bottom-link">私隱政策</a>
            <a href="/terms" class="footer-bottom-link">服務條款</a>
            <a href="/data-deletion" class="footer-bottom-link">資料刪除</a>
            <a href="/sitemap.xml" class="footer-bottom-link">網站地圖</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'AmisFooter',
    computed: {
        currentYear() {
            return new Date().getFullYear()
        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    background: var(--primary-text);
    color: white;
    position: relative;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, var(--accent-color), var(--primary-light));
    }
}

.footer-content {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: var(--spacing-3xl);
    padding: var(--spacing-3xl) 0;
    
    @media (max-width: 1024px) {
        grid-template-columns: 1fr 1fr;
        gap: var(--spacing-2xl);
    }
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: var(--spacing-xl);
    }
}

.footer-section {
    .footer-title {
        font-size: var(--font-size-lg);
        font-weight: 600;
        margin-bottom: var(--spacing-lg);
        color: white;
    }
}

.company-info {
    .company-logo {
        margin-bottom: var(--spacing-lg);
        
        .footer-logo {
            width: 180px;
            height: auto;
            filter: brightness(0) invert(1);
        }
    }
    
    .company-description {
        color: rgba(255, 255, 255, 0.9);
        line-height: 1.6;
        margin-bottom: var(--spacing-lg);
    }
    
    .contact-info {
        .contact-item {
            display: flex;
            align-items: center;
            gap: var(--spacing-sm);
            margin-bottom: var(--spacing-sm);
            color: rgba(255, 255, 255, 0.9);
            
            i {
                color: var(--primary-light);
                width: 16px;
            }
            
            a {
                display: inline-block;
                padding: var(--spacing-sm) 0;
                color: rgba(255, 255, 255, 0.9);
                text-decoration: none;
                transition: var(--transition-fast);
                
                &:hover {
                    color: white;
                }
            }
        }
    }
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
        margin-bottom: var(--spacing-sm);
        
        a {
            display: inline-block;
            padding: var(--spacing-xs) 0;
            color: rgba(255, 255, 255, 0.9);
            text-decoration: none;
            transition: color var(--transition-fast), padding-left var(--transition-fast);
            
            &:hover {
                color: white;
                padding-left: var(--spacing-sm);
            }
        }
    }
}

.social-qr {
    .qr-code {
        text-align: center;
        margin-bottom: var(--spacing-lg);
        
        .qr-image {
            width: 100px;
            height: 100px;
            border-radius: var(--radius-md);
            margin-bottom: var(--spacing-sm);
        }
        
        .qr-text {
            font-size: var(--font-size-sm);
            color: rgba(255, 255, 255, 0.8);
        }
    }
    
    .social-links {
        display: flex;
        gap: var(--spacing-md);
        justify-content: center;
        
        .social-link {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            
            .social-icon {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                object-fit: cover;
            }
        }
    }
}

.footer-bottom {
    background: var(--primary-text-hover);
    padding: var(--spacing-lg) 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    
    .legal-entity {
        margin-bottom: var(--spacing-md);
        padding-bottom: var(--spacing-md);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .legal-entity-line {
            margin: 0 0 4px;
            color: rgba(255, 255, 255, 0.75);
            font-size: var(--font-size-sm);
            line-height: 1.6;
        }

        .legal-entity-en {
            display: block;
            margin-top: 2px;
            font-size: var(--font-size-xs);
            color: rgba(255, 255, 255, 0.75);
        }

        a {
            color: rgba(255, 255, 255, 0.9);
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }

        .legal-entity-sep {
            margin: 0 6px;
            opacity: 0.6;
        }
    }

    .footer-bottom-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        @media (max-width: 768px) {
            flex-direction: column;
            gap: var(--spacing-md);
            text-align: center;
        }
        
        .copyright {
            color: rgba(255, 255, 255, 0.8);
            font-size: var(--font-size-sm);
        }
        
        .footer-bottom-links {
            display: flex;
            gap: var(--spacing-lg);
            
            @media (max-width: 768px) {
                gap: var(--spacing-md);
            }
            
            .footer-bottom-link {
                display: inline-block;
                padding: var(--spacing-sm) 0;
                color: rgba(255, 255, 255, 0.8);
                text-decoration: none;
                font-size: var(--font-size-sm);
                transition: color var(--transition-fast);
                
                &:hover {
                    color: white;
                }
            }
        }
    }
}

// Responsive adjustments
@media (max-width: 1024px) {
    .footer-content {
        .company-info {
            grid-column: 1 / -1;
        }
    }
}

@media (max-width: 768px) {
    .footer-content {
        text-align: center;
        
        .social-links {
            justify-content: center;
        }
    }
}
</style>
